/** Chunked AES-GCM lock files: plaintext is split; each chunk has its own tag on disk. */

export const LOCK_ENC_FORMAT_V1 = 'gcm-v1';
export const LOCK_ENC_FORMAT_CHUNK_V1 = 'gcm-chunk-v1';
export const LOCK_CHUNK_PLAIN_BYTES = 4 * 1024 * 1024;
export const LOCK_GCM_TAG_BYTES = 16;

export function isChunkedLockEncFormat(item) {
  if (!item?.isEncrypted) return false;
  if (item.encFormat === LOCK_ENC_FORMAT_CHUNK_V1) return true;
  if (item.encFormat === LOCK_ENC_FORMAT_V1) return false;
  return !item.encAuthTag;
}

export function lockChunkPlainSize(item) {
  const n = Number(item?.encChunkPlainSize);
  return n > 0 ? n : LOCK_CHUNK_PLAIN_BYTES;
}

export function plainBytesInChunk(chunkIndex, totalPlainBytes, chunkPlainSize) {
  const start = chunkIndex * chunkPlainSize;
  if (start >= totalPlainBytes) return 0;
  return Math.min(chunkPlainSize, totalPlainBytes - start);
}

export function lockChunkCount(totalPlainBytes, chunkPlainSize) {
  if (!totalPlainBytes) return 0;
  return Math.ceil(totalPlainBytes / chunkPlainSize);
}

export function cipherBytesInChunk(chunkIndex, totalPlainBytes, chunkPlainSize) {
  const plain = plainBytesInChunk(chunkIndex, totalPlainBytes, chunkPlainSize);
  return plain ? plain + LOCK_GCM_TAG_BYTES : 0;
}

export function cipherByteOffsetForChunk(chunkIndex, totalPlainBytes, chunkPlainSize) {
  let offset = 0;
  for (let i = 0; i < chunkIndex; i += 1) {
    offset += cipherBytesInChunk(i, totalPlainBytes, chunkPlainSize);
  }
  return offset;
}

export function totalCipherBytes(totalPlainBytes, chunkPlainSize) {
  const n = lockChunkCount(totalPlainBytes, chunkPlainSize);
  let sum = 0;
  for (let i = 0; i < n; i += 1) {
    sum += cipherBytesInChunk(i, totalPlainBytes, chunkPlainSize);
  }
  return sum;
}

/** 12-byte IV with big-endian style increment (chunk index added to the IV). */
export function deriveChunkIvBytes(baseIvBytes, chunkIndex) {
  const iv = new Uint8Array(baseIvBytes);
  if (iv.length !== 12) {
    throw new Error('Invalid lock IV');
  }
  let carry = chunkIndex;
  for (let j = 11; j >= 0 && carry > 0; j -= 1) {
    const sum = iv[j] + (carry & 0xff);
    iv[j] = sum & 0xff;
    carry = Math.floor(carry / 256) + Math.floor(sum / 256);
  }
  return iv;
}
